/**
 * Composable pour la recherche avec autocomplete
 * Centralise la logique de recherche avec suggestions répétée dans plusieurs composants
 */

import {ref} from 'vue'

export const formatPersonDisplayName = (item) => {
    const maritalName = typeof item?.maritalName === 'string' ? item.maritalName.trim() : ''
    const lastName = maritalName || item?.lastname || ''
    return `${item?.firstname || ''} ${lastName}`.trim()
}

export function useSearchAutocomplete(searchFunction, debounceMs = 1000, minLength = 3) {
    const searchTerm = ref('')
    const suggestions = ref([])
    const searchLoading = ref(false)
    let searchTimeout = null

    const onSearch = async () => {
        clearTimeout(searchTimeout)

        if (!searchTerm.value || searchTerm.value.length < minLength) {
            suggestions.value = []
            return
        }

        searchTimeout = setTimeout(async () => {
            doSearch(searchTerm.value)
        }, debounceMs)
    }

    const doSearch = (term) => {
        searchLoading.value = true
        suggestions.value = []
        searchFunction(term).then((results) => {
            suggestions.value = Array.isArray(results)
                ? results
                : (results?.candidacyList || results?.managerList || results?.data || [])
        }).catch((err) => {
            console.error('Search error:', err)
            suggestions.value = []
        }).finally(() => {
            searchLoading.value = false
        })
    }

    const clearSuggestions = () => {
        suggestions.value = []
    }

    const clearSearch = () => {
        searchTerm.value = ''
        suggestions.value = []
    }

    const selectSuggestion = (item, formatCallback) => {
        if (formatCallback) {
            searchTerm.value = formatCallback(item)
        } else {
            searchTerm.value = formatPersonDisplayName(item)
        }
        suggestions.value = []
        return item
    }

    return {
        searchTerm,
        suggestions,
        searchLoading,
        onSearch,
        clearSuggestions,
        clearSearch,
        selectSuggestion
    }
}
